import Vue from "vue";
import { signOut } from "@aws-amplify/auth";
import { AmplifyEventBus } from "aws-amplify-vue";

let sessionExpiryPromise = null;
let sessionExpiryHandled = false;

function isSessionExpiryError(error) {
  return [
    "NotAuthorizedException",
    "UserNotFoundException",
    "UserUnAuthenticatedException",
    "TokenRefreshException",
  ].includes(error?.name);
}

async function handleSessionExpiry() {
  if (sessionExpiryHandled) {
    return sessionExpiryPromise;
  }

  sessionExpiryHandled = true;
  sessionExpiryPromise = (async () => {
    try {
      // Local sign-out clears the cached Cognito tokens even when the remote
      // session can no longer be refreshed.
      await signOut();
    } catch {
      // Continue with local state cleanup and redirect even if sign-out fails.
    } finally {
      AmplifyEventBus.$emit("authState", "sessionExpired");

      // During application startup the notification plugin is installed after
      // the initial session restoration. Deferring avoids a race in that path.
      setTimeout(() => {
        if (typeof Vue.notify === "function") {
          Vue.notify({
            group: "error",
            title: "Lejárt munkamenet",
            text: "A munkamenet lejárt, kérjük jelentkezzen be újra.",
          });
        }
      }, 0);
    }
  })();

  return sessionExpiryPromise;
}

function resetSessionExpiryState() {
  sessionExpiryHandled = false;
  sessionExpiryPromise = null;
}

export { handleSessionExpiry, isSessionExpiryError, resetSessionExpiryState };
